<div [class]="containerClass">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns>{{ firstDayOfPeriodLabel | translate }}</mat-label>
        <mat-select
            required
            name="dayOfMonth"
            #dayOfMonth="ngModel"
            [(ngModel)]="timeOffPolicy.dayOfMonthOne"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            (selectionChange)="previewDataChanged()"
        >
            <mat-option *ngFor="let day of monthlyDays" [value]="day">{{
                'time-off-v3.monthlyDateOption'
                    | translate: { day: day > 0 ? (day | ordinalNumber) : ('time-off-v3.lastDay' | translate) }
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
